<template>
  <div style="width: 100%;height: 100%;">
    
    <img src="/img/bc.png" style="width: 100%;height: 100%;" />
    <!-- 标题栏 -->
    <!-- <van-nav-bar :title="goodsChildName" left-arrow @click-left="onClickLeft" /> -->
    <video v-if="phoneType=='iPhone'" style="width: 100% !important;height: 100% !important;position: fixed;z-index: 9;top: 0px;left: 0px;" controls >
      <source :src="nowInfo.videoUrl" type="video/mp4">
    </video>
    <video :src="nowInfo.videoUrl" v-if="phoneType=='Android'" style="width: 100% !important;height: 100% !important;position: fixed;z-index: 9;top: 0px;left: 0px;"  controls>
      <source :src="nowInfo.videoUrl" type="video/mp4">
    </video>
    <!-- <div @click="toPublish"  >{{ phoneType }}</div> -->
    <div @click="toPublish" class="cover-fb" >一键发布</div>
    <div class="loading" v-show="showLoading">
        <img src="img/timg.gif" alt="">
      </div>
  </div>
</template>
<!-- <script src="https://lf3-static.bytednsdoc.com/obj/eden-cn/fljpeh7hozbf/douyin_open/cdn/dy_open_util_v0.0.6.umd.js"></script> -->
<!-- <script src="https://unpkg.byted-static.com/bridge/douyin_open/1.0.10/lib/douyin_open.umd.js"></script> -->
<script>
import TimUiMedia from '@/components/TimUiMedia'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
export default {
  name: 'publishVideo',
  components: {
    TimUiMedia
  },
  data () {
    return {
      requestHeadUrl: 'https://xwt.kequbang.com',
      // requestHeadUrl: 'http://localhost:8280',
      // requestHeadUrl: 'http://192.168.1.15:8280',
      current: 1,
      showModal: false,
      list: [],
      nowInfo:{},
      jy: true,
      phoneType: '1',
      kuInfo:{},
      openId: '',
      showLoading: false
    }
  },
  created () {
    const thisObj = this
    document.title  = '发布视频到抖音'
    // let params = thisObj.$route.query
    let userAgentInfo = navigator.userAgent;
    thisObj.phoneType = userAgentInfo
    if(userAgentInfo.match("iPhone")) {  
      thisObj.phoneType = "iPhone"
        // return "iPhone";  
    } else if(userAgentInfo.match("Android")) {  
      thisObj.phoneType = "Android"
        // return "Android";  
    } 
  },
  watch: {
    crruentMediaObj: function (n, o) {
      const thisObj = this
      // 判断是否是第一次加载此页面
      if (o.goodsChildId === undefined) {
        thisObj.$refs.mediaDom.onPause()
        return
      }
      if (o.goodsChildId !== n.goodsChildId) {
        thisObj.$refs.mediaDom.onReplay()
      }
    }
  },
  destroyed () {
      if(this.personFootInfo!=null){
        this.leavePersonFoot()
      }
  },
  mounted () {
    const thisObj = this
    // setTimeout(function () {
    //   thisObj.showLoading = false
      thisObj.onLoad()
    // }, 1500)
  },
  methods: {
    onLoad: function () {
      var rr = window.location.href.split('?')
      console.log(rr[rr.length-1])
      // alert(rr[rr.length-1])
      var ciphertext = rr[rr.length-1]
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/api/clip/get_gallery_by_id?id='+ciphertext, {}).then(res => {
        // console.log(res)
          console.log(res.data)
          thisObj.kuInfo = res.data
          // var titleList = JSON.parse(thisObj.kuInfo.releaseTitle)
          // console.log(titleList)
          // var randomNumber = Math.floor(Math.random() * titleList.length);
          // var tit = titleList[randomNumber]
          // console.log(tit)
      }).catch(function (error) {
      })
      thisObj.$api.get(thisObj.requestHeadUrl + '/api/clip/get_clip_video_noPub?id='+ciphertext, {}).then(res => {
        // console.log(res)
          thisObj.list = res.data
          if (!res.data || res.data.length<1) {
            thisObj.$util.requetServerError('该组视频已全部发布！')
            return
          }
          var randomNumber = Math.floor(Math.random() * res.data.length);
          console.log(res.data.length)
          console.log(randomNumber)
          thisObj.nowInfo = res.data[randomNumber]
      }).catch(function (error) {
      })
      const sdk = window.DouyinOpenJSBridge;
      const url = location.href;
      thisObj.$api.get(thisObj.requestHeadUrl + '/dyUser/getAllSignInfo?url=' + url, {}).then(res => {
        var data = res.data
        thisObj.signInfo = data
        console.log(sdk)
        sdk.config({
          params: {
            client_key: 'aw167hj16o0xd6k1', // clientKey在你的网页应用申请通过后得到
            signature: data.signature, // 服务端计算的签名，该签名被抖音开放平台验证通过后方可调用jsb方法
            timestamp: data.timestamp, // 时间戳
            nonce_str: data.nonceStr,
            url:url, // 为应用申请的 JSB 安全域名下的链接，需要携带协议。e.g. https://jsb.security.domain/page.html
          },
          
        });
        
        sdk.ready(() => {
          
        });
        sdk.error((res) => {
          // alert("111")
          // alert(JSON.stringify(res))// Config error回调
        });
      }).catch(function (error) {
      })
      // setTimeout(function () {
      //   thisObj.jy = false
      // }, 1000)
    },
    toPublish () {
      // script 引入
      var thisObj = this
      const sdk = window.DouyinOpenJSBridge;
        sdk.showOpenAuth({
            params: {
              client_key:'aw167hj16o0xd6k1',
              state: '',
              scopes: {
                user_info: 0, // 0: 必选；1: 可选，默认不选中； 2: 可选，默认选中
              },          
              response_type: 'code'
            },
            success: ({ ticket, grant_permissions }) => {
              // ticket： Oauth 凭据，详见下方说明
              // alert(ticket)
              thisObj.$api.get(thisObj.requestHeadUrl + '/dyUser/setSignInfo?code=' + ticket, {}).then(res => {
                if (res.state) {
                  thisObj.openId = res.data.open_id
                  thisObj.toPublishVideo()
                  // thisObj.$util.showSuccessMsg("用户绑定成功");
                } else {
                  thisObj.$util.showSuccessMsg("请先在“抖推招”平台“账号管理”模块完成授权");
                }
                // location.href = "https://open.douyin.com/platform/oauth/connect/?client_key=aw167hj16o0xd6k1&"+
                // "response_type=code&scope=video.create.bind&redirect_uri=https://zxy.kqbang.cn/empower"
              }).catch(function (error) {
              })
              // alert(grant_permissions)
              // grant_permissions： String 类型，用户授权的所有 scope，以“,”拼接，例：user_info,mobile
            },
            error: function (res) {
              // alert("22")
              // alert(JSON.stringify(res))
              setTimeout(function () {
                thisObj.toPublish2()
              }, 1000)
            },
          });
      
    },
    toPublish2 () {
      // script 引入
      var thisObj = this
      const sdk = window.DouyinOpenJSBridge;
      const url = location.href;
      thisObj.$api.get(thisObj.requestHeadUrl + '/dyUser/getAllSignInfo?url=' + url, {}).then(res => {
        var data = res.data
        thisObj.signInfo = data
        console.log(sdk)
        sdk.config({
          params: {
            client_key: 'aw167hj16o0xd6k1', // clientKey在你的网页应用申请通过后得到
            signature: data.signature, // 服务端计算的签名，该签名被抖音开放平台验证通过后方可调用jsb方法
            timestamp: data.timestamp, // 时间戳
            nonce_str: data.nonceStr,
            url:url, // 为应用申请的 JSB 安全域名下的链接，需要携带协议。e.g. https://jsb.security.domain/page.html
          },
          
        });
        
        sdk.ready(() => {
          
        });
        sdk.error((res) => {
          // alert("111")
          // alert(JSON.stringify(res))// Config error回调
        });
        sdk.showOpenAuth({
            params: {
              client_key:'aw167hj16o0xd6k1',
              state: '',
              scopes: {
                user_info: 0, // 0: 必选；1: 可选，默认不选中； 2: 可选，默认选中
              },          
              response_type: 'code'
            },
            success: ({ ticket, grant_permissions }) => {
              // ticket： Oauth 凭据，详见下方说明
              // alert(ticket)
              thisObj.$api.get(thisObj.requestHeadUrl + '/dyUser/setSignInfo?code=' + ticket, {}).then(res => {
                if (res.state) {
                  thisObj.openId = res.data.open_id
                  thisObj.toPublishVideo()
                  // thisObj.$util.showSuccessMsg("用户绑定成功");
                } else {
                  thisObj.$util.showSuccessMsg("请先在“抖推招”平台“账号管理”模块完成授权");
                }
                // location.href = "https://open.douyin.com/platform/oauth/connect/?client_key=aw167hj16o0xd6k1&"+
                // "response_type=code&scope=video.create.bind&redirect_uri=https://zxy.kqbang.cn/empower"
              }).catch(function (error) {
              })
              // alert(grant_permissions)
              // grant_permissions： String 类型，用户授权的所有 scope，以“,”拼接，例：user_info,mobile
            },
            error: function (res) {
              // alert("22")
              // alert(JSON.stringify(res))
            },
          });
      }).catch(function (error) {
      })
      
    },
    toPublishVideo () {
      // script 引入
      var thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/celebrity/getSignInfo', {}).then(res => {
        console.log(res.data)
          var data = res.data
          // const schema = window.dy_open_util.serialize({
          //   share_type: "h5",
          //   client_key: 'aw167hj16o0xd6k1',
          //   nonce_str: data.nonceStr,
          //   timestamp: data.timestamp,
          //   signature: data.signature,
          //   video_path: 'https://kequbang.com/allFile/fe2286cdfd911886b0a45fc5137bd4b5.mp4',
          //   // hashtag_list: JSON.stringify(["hashtag1", "hashtag2"]),
          //   // micro_app_info: JSON.stringify({
          //   //   appId: "wx615c99a9cf02ca11",
          //   //   appTitle: "小程序title",
          //   //   description: "小程序描述语",
          //   //   appUrl: "pages/index/index",
          //   // }),
          //   poi_id: '6680111338259286030'
          // });
          const url = new URL("snssdk1128://openplatform/share");
          var query = url.searchParams;
          query.append("client_key", 'aw167hj16o0xd6k1');
          query.append("state", data.shareId);
          query.append("nonce_str", data.nonceStr);
          query.append("timestamp", data.timestamp);
          query.append("signature", data.signature);
          query.append("share_type", "h5");
          // query.append(
          //   "image_path",
          //   "https://sf3-cdn-tos.douyinstatic.com/obj/douyin-open-static/tiktok.open/home/d_logo.png"
          // );
          // query.append("share_to_publish", "0");
          query.append("video_path", thisObj.nowInfo.videoUrl);
          // const hashTags = ["hashtag1", "hashtag2", "hashtag3", "天气不错"];
          // query.append("hashtag_list", JSON.stringify(hashTags));
          query.append("hashtag_list", thisObj.nowInfo.topic);
          if(thisObj.nowInfo.poiId) {
            query.append("poi_id", thisObj.nowInfo.poiId);
          }
          var titleList = JSON.parse(thisObj.kuInfo.releaseTitle)
          var randomNumber = Math.floor(Math.random() * titleList.length);
          var tit = titleList[randomNumber]
          query.append("title", tit);
          

          // query.append(
          //   "micro_app_info",
          //   JSON.stringify({
          //     appId: "小程序appid",
          //     appTitle: "小程序title",
          //     description: "小程序描述语",
          //     appUrl: "pages/movie/index",
          //   })
          // );
          // console.log(url)
          if (!thisObj.openId) {
            thisObj.$util.showSuccessMsg("该抖音号未在“账号管理”模块完成授权，请先在“抖推招”平台“账号管理”模块完成授权");
            return
          }
          thisObj.$api.get(thisObj.requestHeadUrl + '/dyUser/updatePublish?id='+thisObj.nowInfo.id+'&openId=' + thisObj.openId + '&shareId=' + data.shareId, {}).then(res => {
            // console.log(res)
            // thisObj.list = res.data
            // thisObj.nowInfo = res.data[0]
          }).catch(function (error) {
          })
          // alert(url)
          location.href = url
      }).catch(function (error) {
      })
      
    },
    // 目录/简介 tab切换
    switchTab (e) {
      let current = e.currentTarget.dataset.current
      this.current = current
    },
    // 生成图片
    toImg () {
      //   setTimeout(function () {
      // that.toImg()
      html2canvas(document.querySelector('#captureId')).then(canvas => {
        let imgUrl = canvas.toDataURL('image/png')
        let that = this
        that.dataURL = imgUrl
        // eslint-disable-next-line handle-callback-err
      }).catch(error => {
      })
      //   }, 500)
      this.showLoading = false
    },
    
  }
}
</script>
<style scoped>
.TimUi-audio-control {
  z-index: 20;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  height: 90px;
  padding: 0 35px;
  background: rgba(0, 0, 0, 0.6);
}
.TimUi-audio-control .TimUi-media {
  visibility: hidden;
}
.TimUi-audio-control .iconfont.fs-24 {
  margin: 0 4% 0 0;
  font-size: 24px;
  color: #fff;
}
.TimUi-audio-control .progress-bar {
  width: 100%;
  color: #fff;
}
.TimUi-audio-control .progress-bar .progress-slider {
  width: 92%;
  margin: 0 4%;
  padding: 12px 0 0 0;
}
.TimUi-audio-control .progress-bar .van-slider {
  width: 100%;
}
.cover-fb {
  font-size: 40px;
  position: fixed;
  z-index: 999;
  bottom: 30px;
  width: 100%;
  background-color: rgb(230, 39, 90);
  color: #fff;
  text-align: center;
  padding: 20px;
  border-radius: 30px;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 121;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.loading img {
  width: 4rem;
  height: 4rem;
  margin: 7.5rem auto;
}
</style>
